import React, { Component } from 'react';
// import ContactForm from './ContactForm';
// import axios from 'axios';
import jsonData from "../../db.json"
class ContactSection extends Component {
    state = {
        data: jsonData.themeOneContactSection,
        iconList: jsonData.themeOneContactSection.iconList
    }

    render() {
        return (
            <section id="contact" className="contact-area bg-gray ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-6">
                        {/* Section Heading */}
                        <div className="section-heading text-center">
                        <h2 className="text-capitalize">{this.state.data.heading}</h2>
                        <p className="d-none d-sm-block mt-4">{this.state.data.headingText}</p>
                        <p className="d-block d-sm-none mt-4">{this.state.data.headingTexttwo}</p>
                        </div>
                    </div>
                    </div>
                    <div className="row justify-content-center">
                    <div className="col-12 col-md-5">
                        {/* Contact Us */}
                        <div className="contact-us">
                        <p className="mb-3">{this.state.data.content}</p>
                            <ul>
                                {this.state.iconList.map((item, idx) => {
                                    return(
                                        <li key={`ci_${idx}`} className="py-2">
                                            <p className="media" style={{alignItems: 'center', overflow: 'hidden'}}>
                                                <div className="social-icon mr-3" style={{flexShrink: 0}}>
                                                    <i className={item.iconClass} />
                                                </div>
                                                <img src={item.text} alt={`Contact Icon ${idx + 1}`} style={{maxWidth: '100%', height: 'auto', minWidth: 0}} />
                                            </p>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                    {/* <div className="col-12 col-md-6 pt-4 pt-md-0">
                        <ContactForm />
                    </div> */}
                    </div>
                </div>
            </section>
        );
    }
}

export default ContactSection;